import { TextArea } from '@soteria/design-system-ve';
import React from 'react';

import * as styles from './TextInputCard.css';

interface TextInputCardProps {
  textContent: string;
  hasError: boolean;
  onTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: () => void;
  onClear: () => void;
  textAreaRef: React.RefObject<HTMLTextAreaElement | null>;
}

/**
 * Text Input Card for typing text content
 */
export function TextInputCard({ textContent, hasError, onTextChange, onFocus, onClear, textAreaRef }: TextInputCardProps) {
  return (
    <div className={styles.textInputContainer}>
      <TextArea
        ref={textAreaRef}
        hasError={hasError}
        placeholder="Type or paste your text content here..."
        rows={4}
        size={{ height: 160 }}
        value={textContent}
        onChange={onTextChange}
        onFocus={onFocus}
      />
      {textContent && (
        <button className={styles.clearButton} title="Clear text" onClick={onClear}>
          <svg fill="none" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor" />
          </svg>
        </button>
      )}
    </div>
  );
}
